import React from 'react';
import SelectNested from "../../../elements/SelectNested";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";

const PositionCertification = ({index, state, certificationsList, onRemove}) => {
  const propertyName = `requiredCertifications[${index}]`;

  return (
    <div className="position-requirement-row">
      <div className="position-requirement-select">
        <SelectNested
          propertyName={propertyName}
          state={state}
          itemsList={certificationsList}
          displayNames={["name"]}
          showInput={false}
          showDelete={false}
          useId={false}
        />
      </div>
      <button
        type="button"
        className="btn btn-outline-danger position-requirement-remove"
        onClick={(e) => {
          e.preventDefault();
          onRemove();
        }}
        aria-label="Usuń wymagany certyfikat"
        title="Usuń"
      >
        <FontAwesomeIcon icon={faTrashAlt}/>
      </button>
    </div>
  );
};

export default PositionCertification;
